import React from 'react';
import { appDocumentTitle } from '../../appMeta';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { ManageMasterTabScreen } from './TabScreens/ManageMaster';

/** Superadmin: permission groups and accesses at `/superadmin/permissions`. */
export function SuperadminPermissionsPage() {
  useDocumentTitle(appDocumentTitle('Permission'));

  return (
    <PageShell title="Permission">
      <ManageMasterTabScreen />
    </PageShell>
  );
}
